import React, { useState, useMemo } from 'react';
import { createPortal } from 'react-dom';

import { ToastContext } from './ToastContext';
import { Toast } from './Toast';

// Create a random ID
function generateUEID() {
  let first = (Math.random() * 46656) | 0;
  let second = (Math.random() * 46656) | 0;
  first = ('000' + first.toString(36)).slice(-3);
  second = ('000' + second.toString(36)).slice(-3);

  return first + second;
}

export const ToastProvider = (props) => {
  const [toasts, setToasts] = useState([]);
  const [buttomToasts, setButtomToasts] = useState([]);
  const open = (content, status, isUndo, onCallBack, isUndoContent) =>
    setToasts([
      { id: generateUEID(), content, status, isUndo, onCallBack, isUndoContent },
    ]);
  const buttomOpen = (content, status, isUndo, onCallBack, isUndoContent) =>
    setButtomToasts([
      { id: generateUEID(), content, status, isUndo, onCallBack, isUndoContent },
    ]);
  const buttomClose = (id) =>
    setButtomToasts((currentToasts) =>
      currentToasts.filter((toast) => toast.id !== id)
    );
  const close = (id) =>
    setToasts((currentToasts) =>
      currentToasts.filter((toast) => toast.id !== id)
    );
  const contextValue = useMemo(() => ({ open, buttomOpen }), []);
  return (
    <ToastContext.Provider value={contextValue}>
      {props.children}

      {toasts.length > 0 && createPortal(
        <div className="toasts-wrapper">
          {toasts.map((toast) => (
            <Toast key={toast.id} status={toast.status} isUndo={toast.isUndo} onCallBack={toast.onCallBack} isUndoContent={toast.isUndoContent} close={() => close(toast.id)}>
              {toast.content}
            </Toast>
          ))}
        </div>,
        document.body
      )}
      {buttomToasts.length > 0 && createPortal(
        <div className="toasts-wrapper-buttom">
          {buttomToasts.map((toast) => (
            <Toast key={toast.id} status={toast.status} isUndo={toast.isUndo} onCallBack={toast.onCallBack} isUndoContent={toast.isUndoContent} close={() => buttomClose(toast.id)}>
              {toast.content}
            </Toast>
          ))}
        </div>,
        document.body
      )}
    </ToastContext.Provider>
  );
};
